import React, { useState } from 'react';
import Board from "./Board"
import Login from "./Login";
// import { getLocalToken } from "../utils/localstorage";
import { ToastContainer } from "react-toastify";
// import { getLocalOrderStatusSettings } from "../utils/utils";

function App() {
    const [token, setToken] = useState();
    const [orderStatusSetting, setOrderStatusSetting] = useState();
    // if (!token && !orderStatusSetting) {
    //     try {
    //         const localToken = getLocalToken();
    //         if (localToken) {
    //             setToken(localToken);
    //         }
    //     } catch (err) {}
    // }
    if (!token) {
        return (
            <div className="text-center mt-5">
                <Login setToken={setToken} setOrderStatusSetting={setOrderStatusSetting} />
                <ToastContainer />
            </div>
        )
    } else {
        return (<div className="text-center">
            <Board />
            <ToastContainer />
        </div>)
    }

}

export default App;
